export class Character {
    constructor(c, d) {
        this.id = c && typeof c.id !== 'undefined' ? c.id : "";
        this.name = c && typeof c.name !== 'undefined' ? c.name : "";
        this.hideName = c && typeof c.hideName !== 'undefined' ? c.hideName : "";
        this.avatar = c && typeof c.avatar !== 'undefined' ? c.avatar : "";
        this.player = c && typeof c.player !== 'undefined' ? c.player : "";
        this.playerName = c && typeof c.playerName !== 'undefined' ? c.playerName : "";
        this.dataset = c && typeof d !== 'undefined' ? d : new Dataset();
    }
}

export class Dataset {
    constructor(d) {
        this.avatar = d && typeof d.avatar !== 'undefined' ? d.avatar : "";
        
        this.redMax = d && typeof d.redMax !== 'undefined' ? d.redMax : "";
        this.redCurrent = d && typeof d.redCurrent !== 'undefined' ? d.redCurrent : "";
        this.redVisibility = d && typeof d.redVisibility !== 'undefined' ? d.redVisibility : "hidden";
        this.redValue = Math.min(parseFloat(this.redCurrent) / (parseFloat(this.redMax) || 1), 1);
        this.redView = (this.redCurrent || '0') + (this.redMax.length > 0 ? '/' : '') + this.redMax;
        
        this.blueMax = d && typeof d.blueMax !== 'undefined' ? d.blueMax : "";
        this.blueCurrent = d && typeof d.blueCurrent !== 'undefined' ? d.blueCurrent : "";
        this.blueVisibility = d && typeof d.blueVisibility !== 'undefined' ? d.blueVisibility : "";
        this.blueValue = Math.min(parseFloat(this.blueCurrent) / (parseFloat(this.blueMax) || 1), 1);
        this.blueView = (this.blueCurrent || '0') + (this.blueMax.length > 0 ? '/' : '') + this.blueMax;
        
        this.greenMax = d && typeof d.greenMax !== 'undefined' ? d.greenMax : "";
        this.greenCurrent = d && typeof d.greenCurrent !== 'undefined' ? d.greenCurrent : "";
        this.greenVisibility = d && typeof d.greenVisibility !== 'undefined' ? d.greenVisibility : "";
        this.greenValue = Math.min(parseFloat(this.greenCurrent) / (parseFloat(this.greenMax) || 1), 1);
        this.greenView = (this.greenCurrent || '0') + (this.greenMax.length > 0 ? '/' : '') + this.greenMax;

        this.sizeX = d && typeof d.sizeX !== 'undefined' ? parseInt(d.sizeX) : 1;
        this.sizeY = d && typeof d.sizeY !== 'undefined' ? parseInt(d.sizeY) : 1;
    }
}